import { render, staticRenderFns } from "./NewDamagedInvoice.vue?vue&type=template&id=046ad624&"
import script from "./NewDamagedInvoice.vue?vue&type=script&lang=js&"
export * from "./NewDamagedInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports